import React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';

import { getJobApplicationIframeUrl } from '../../../lib/greenHouse/greenHouseApi';

const JobApplicationContainer = styled('div')`
  margin: 1rem;
  width: 100%;
`;

const StyledButton = styled(Button)`
  margin: 1rem;
`;

const StyledIframe = styled('iframe')`
  border: 1px solid theme.palette.grey[400];
  border-radius: 6px;
`;

export const JobApplicationFrame = ({
  boardName,
  jobId,
  source,
  backlinkHandler,
}: {
  boardName: string;
  jobId: string;
  source?: string;
  backlinkHandler: any;
}): JSX.Element => {
  return (
    <Container maxWidth="lg">
      <JobApplicationContainer>
        <StyledButton
          variant="contained"
          color="secondary"
          onClick={backlinkHandler}
        >
          Zurück zur Liste
        </StyledButton>
        <StyledIframe
          id="grnhse_iframe"
          width="100%"
          allow="geolocation"
          title="Greenhouse Job Board"
          src={getJobApplicationIframeUrl(boardName, jobId, source)}
          height="3700"
        ></StyledIframe>
      </JobApplicationContainer>
    </Container>
  );
};
